import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CreateProfileInfo from '../Sections/CreateProfile/CreateProfileInfo';
import CreateProfileForm from '../Sections/CreateProfile/CreateProfile';
import FortisButton from '../Basic/FortisButton';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import LinkButton from '../Basic/LinkButton';
import { nextStepClicked } from '../../actions';
import util from '../../lib/util';
import * as consts from '../../constants';

class CreateProfile extends React.Component {
  constructor() {
    super();
    this.state = { nextStepSuccess: false };
    {/*Here we can check if the state.form.emailAddress has any value, put it for profileEmailAddress(Communication offer) */}
  }
  componentWillReceiveProps(p) {
    if (p.isCreateProfileSuccess && !this.state.nextStepSuccess) {
      util.trackGoogleAnalytics(this.props.pageName,'Create Profile','Create Profile Success');   
      const nextStep =  (p.pageName == consts.NEW_GAS_LINE_NAME) ? 3 : 2;     
      p.onNextStepClicked(nextStep);
      this.setState({ nextStepSuccess: true });
    }
  }

  render() {
    const p = this.props;
    return (
      <div>
        <CreateProfileInfo {...p}/>
        {
          p.isCreateProfileSelected ?
            <div>
              <CreateProfileForm {...p} />
            </div>
            :
            <ButtonToolbar  style={{display: "inline-flex"}}>
              <LinkButton text="Back" onClick={p.onBackClick} />
              <FortisButton onClick={p.onNextClick} text="Next step" />
              <LinkButton text="Cancel" onClick={p.onCancelClick} />
            </ButtonToolbar>
        }

      </div>
    );
  }
}

CreateProfile.propTypes = {
  id: PropTypes.string.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isCreateProfileSelected: PropTypes.bool,
  isCreateProfileSuccess: PropTypes.bool,
  pageName: PropTypes.string
};
function mapDispatchToProps(dispatch) {
  return {
    onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
  };
}
function mapStateToProps(state) {
  return {
    isCreateProfileSelected: state.form.createProfileSelectOption && (state.form.createProfileSelectOption == 1),
    isCreateProfileSuccess: state.gas.user && state.gas.user.isCreateProfileSuccess,
    pageName: state.gas.pageName,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfile);


